import { render, staticRenderFns } from "./DevicePriceComparison.vue?vue&type=template&id=1aa14051&"
import script from "./DevicePriceComparison.vue?vue&type=script&lang=js&"
export * from "./DevicePriceComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports